<div class="section-title" style="padding-top: 20px; padding-bottom: 20px;">
  <h2>
    All the Winning and Honorable Mention entries of DART Student Art Contest.
  </h2>
  <div class="main-div">
    <mat-card class="bestOfShow-card" *ngIf="bestOfShow">
      <mat-card-header>
        <div mat-card-avatar class="winner-header-image"></div>
        <mat-card-title>
          {{bestOfShow.voteChoice}}: {{bestOfShow.firstName}} {{bestOfShow.lastName}}
        </mat-card-title>
        <mat-card-subtitle>{{ bestOfShow.schoolName }} - {{ bestOfShow.grade }}</mat-card-subtitle>
      </mat-card-header>
      <img mat-card-image [src]="bestOfShow.pictureThumbName" alt="" (click)="open(bestOfShow)" class="picture">
    </mat-card>
  </div>
</div>

<mat-tab-group mat-align-tabs="start" style="padding-top: 20px" *ngIf="contestWinners">
  <mat-tab label="K - 2nd Grade">
    <winners-gallery [contestWinners]="gradeKTo2Winners" [gradeCategoryName]="gradeKTo2Label"></winners-gallery>
  </mat-tab>
  <mat-tab label="3rd - 5th Grade">
    <winners-gallery [contestWinners]="grade3To5Winners" [gradeCategoryName]="grade3To5Label"></winners-gallery>
  </mat-tab>
  <mat-tab label="6th - 8th Grade">
    <winners-gallery [contestWinners]="grade6To8Winners" [gradeCategoryName]="grade6To8Label"></winners-gallery>
  </mat-tab>
  <mat-tab label="9th - 12th Grade">
    <winners-gallery [contestWinners]="grade9To12Winners" [gradeCategoryName]="grade9To12Label"></winners-gallery>
  </mat-tab>
</mat-tab-group>

<ngx-spinner [fullScreen]="true" type="square-jelly-box" size="medium">
  <p class="loading">Loading ...</p>
</ngx-spinner>
